export const UPDATE_ROOM_ERROR = "UPDATE_ROOM_ERROR";
export const UPDATE_ROOM_ERP_INTEGRATIONS_ERROR = "UPDATE_ROOM_ERP_INTEGRATIONS_ERROR";
export const SWAP_ROOM_ERROR = "SWAP_ROOM_ERROR";
export const ROOM_NOT_FOUND_ERROR = "ROOM_NOT_FOUND_ERROR";
export const GUESTY_LISTING_ALREADY_LINKED_ERROR = "GUESTY_LISTING_ALREADY_LINKED_ERROR";

export const CREATE_ROOM_ERROR = "CREATE_ROOM_ERROR";
export const CREATE_ROOM_ERP_INTEGRATIONS_ERROR = "CREATE_ROOM_ERP_INTEGRATIONS_ERROR";
export const AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR =
  "AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR";
export const ICNEA_PROPERTY_ALREADY_LINKED_ERROR = "ICNEA_PROPERTY_ALREADY_LINKED_ERROR";
